import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    Row,
    Col,
    message,
    Spin
} from "antd";
import { LeftOutlined, RightOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import IntegerInput from "../../components/IntergerInput";
import _BankAdminService from "../../modules/BankAdminService";
import SidebarLayout from "../BankerUI/SidebarLayout";
import ButtonComponent from "../../components/Button/Button";
import FormItemInput from "../../components/FormItems/FormItemInput";
import FormItemTextArea from "../../components/FormItems/FormItemTextArea";
import FormItemIntegerInput from "../../components/FormItems/FormItemIntegerInput";


const { Title } = Typography;

const BankAdminProfessionalDetails = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const BankerId = localStorage.getItem("BankAdminId");
    const [proffesionalDetails, setProffesionalInfoDetails] = useState({});
    const [form] = Form.useForm();
    const locationState = useLocation();
    let data = locationState.state;
    let BankerIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.BankerId) {
        BankerIdFromProfile = data.BankerId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    const [BankerFromProfileID] = useState(BankerIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);

    useEffect(() => {
        getProffesionalDetailsById();
    }, [])
    useEffect(() => form.resetFields(), [proffesionalDetails]);
    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Id: BankerFromProfileID ? BankerFromProfileID : BankerId,
                ScreenName: "proffesionaldetails",
                JobRole: values.jobRole,
                BankName: values.institutionName,
                OfficeAddress: values.officeAddress,
                City: values.city,
                State: values.state,
                ZipCode: values.zipCode,
                IdentificationNumber: values.idNumber,
                PhotoPath: "",
            }
            const res = await _BankAdminService.UpdateBankAdminData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message)
                if (isFromDashboard) {
                    history.push({ pathname: routes.bankadminprofile.path, state: { BankerId } });
                } else {
                    history.push(routes.bankadmindashboard.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };
    const getProffesionalDetailsById = async () => {
        const resObj = await _BankAdminService.getBankAdminInformationByBankAdminId(BankerFromProfileID ? BankerFromProfileID : BankerId);
        if (resObj.data) {
            const res = resObj.data.Obj;
            setProffesionalInfoDetails({
                jobRole: res.JobRole,
                institutionName: res.BankName,
                officeAddress: res.OfficeAddress,
                city: res.City,
                state: res.State,
                zipCode: res.ZipCode,
                idNumber: res.IdentificationNumber,
            });
        }

    }
    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.bankadminprofile.path, state: { BankerId } });
        } else {
            history.push(routes.bankadminpersonaldetails.path);
        }
    }

    // const beforeUpload = (file) => {
    //     const isImage = file.type === "image/png" || file.type === "image/jpeg";
    //     const isSizeOk = file.size / 1024 >= 155 && file.size / 1024 <= 350;
    //     if (!isImage) {
    //         message.error("Only PNG or JPEG files are allowed!");
    //     }
    //     if (!isSizeOk) {
    //         message.error("File size must be between 155KB and 350KB!");
    //     }
    //     return isImage && isSizeOk;
    // };



    return (
        <Spin spinning={loading}>
            <LeftLayout>
                <div className="form-container card-section">

                    <Title level={3} className="page-title" style={{ marginBottom: 24 }}>
                        Professional Details
                    </Title>

                    <Form layout="vertical" onFinish={onFinish} requiredMark={true}
                        initialValues={proffesionalDetails} form={form}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                {/* <Form.Item
                            label="Job Role"
                            name="jobRole"
                            rules={[{ required: true, message: "Job Role is required" }]}
                            className="w50"
                        >
                            <Input size="large" placeholder="Enter Job Role" maxLength={30} />
                        </Form.Item> */}

                                <FormItemInput
                                    label="Job Role"
                                    name="jobRole"
                                    placeholder="Enter Job Role"
                                    rules={[
                                        { required: true, message: "Job Role is required" },
                                    ]}
                                    // disabled={sponserId > 0}
                                    maxLength={30}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>

                                {/* <Form.Item
                            label="Institution Name"
                            name="institutionName"
                            rules={[{ required: true, message: "Institution Name is required" }]}
                            className="w50"
                        >
                            <Input size="large" placeholder="Enter Institution Name" maxLength={300} />
                        </Form.Item> */}

                                <FormItemInput
                                    label="Institution Name"
                                    name="institutionName"
                                    placeholder="Enter Institution Name"
                                    rules={[
                                        { required: true, message: "Institution Name is required" },
                                    ]}
                                    // disabled={sponserId > 0}
                                    maxLength={300}
                                />

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24}>
                                {/* <Form.Item
                            label="Office Address (Street Address, P.O Box)"
                            name="officeAddress"
                            rules={[{ required: true, message: "Office Address is required" }]}
                            
                        >
                            <Input.TextArea size="large" placeholder="Enter Office Address (Street Address, P.O Box)" rows={3} maxLength={500} />
                        </Form.Item> */}
                                <FormItemTextArea
                                    name="officeAddress"
                                    label="Office Address (Street Address, P.O Box)"

                                    rules={[
                                        { required: true, message: "Office Address is required" }
                                    ]}
                                    rows={3} maxLength={500}
                                />

                                {/* <Form.Item
                            label="City"
                            name="city"
                            className="w50"
                            rules={[
                                {
                                    required: true,
                                    message: 'City is required',
                                },
                                {
                                    pattern: /^[A-Za-z\s]+$/,

                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Enter City"
                                maxLength={30}
                                onKeyPress={(e) => {
                                    const char = String.fromCharCode(e.which);
                                    if (!/^[A-Za-z\s]$/.test(char)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item> */}
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                <FormItemInput
                                    label="City"
                                    name="city"
                                    placeholder="Enter City"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'City is required',
                                        },
                                        {
                                            pattern: /^[A-Za-z\s]+$/,

                                        },
                                    ]}
                                    // disabled={sponserId > 0}
                                    maxLength={30}
                                />

                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>
                                {/* <Form.Item
                            label="State"
                            name="state"
                            className="w50"
                            rules={[
                                {
                                    required: true,
                                    message: 'State is required',
                                },
                                {
                                    pattern: /^[A-Za-z\s]+$/,

                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Enter State"
                                maxLength={30}
                                onKeyPress={(e) => {
                                    const char = String.fromCharCode(e.which);
                                    if (!/^[A-Za-z\s]$/.test(char)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item> */}


                                <FormItemInput
                                    label="State"
                                    name="state"
                                    placeholder="Enter State"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'State is required',
                                        },
                                        {
                                            pattern: /^[A-Za-z\s]+$/,

                                        },
                                    ]}
                                    // disabled={sponserId > 0}
                                    maxLength={30}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12}>

                                {/* <Form.Item
                            label="Zip Code"
                            name="zipCode"
                            className="w50"
                            rules={[
                                {
                                    required: true,
                                    message: 'Zip Code is required',
                                }
                            ]}
                        >
                            <IntegerInput placeholder="Enter Zip Code" maxLength={20} />
                        </Form.Item> */}
                                <Form.Item
                                    label="Zip Code"
                                    name="zipCode"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Zip Code is required',
                                        },
                                        {
                                            pattern: /^\d{5}(-\d{4})?$/,
                                            message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter Zip Code"
                                        maxLength={10} // Supports 12345-6789
                                    />
                                </Form.Item>

                            </Col>
                            {/* <Form.Item
                            label="ID Number"
                            name="idNumber"
                            rules={[{ required: true, message: "ID Number is required" }]}
                            className="w50"
                        >
                            <Input size="large" placeholder="Enter ID Number" maxLength={30} />
                        </Form.Item> */}

                            {/* <Form.Item
                            label="Photo Of ID"
                            name="photoOfId"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => Array.isArray(e) ? e : e && e.fileList}
                            extra="Format: png, jpeg     Size: 155k-350k"
                        >
                            <Upload beforeUpload={beforeUpload} maxCount={1}>
                                <Button icon={<UploadOutlined />}>Select a file</Button>
                            </Upload>
                        </Form.Item> */}
                            <Col xs={24} sm={24} md={24} lg={24}>
                                <Form.Item>
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                        <ButtonComponent type="default" onClick={onBack} text="Go Back" icon={<LeftOutlined />} />
                                        <ButtonComponent
                                            className="createUserButtonprimary"
                                            text={
                                                <span>
                                                    Save And Proceed <ArrowRightOutlined />
                                                </span>
                                            }
                                            // text="Save And Proceed"
                                            htmlType="submit"
                                            type="primary"

                                        />
                                        {/* <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button> */}
                                        {/* <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button> */}
                                    </div>
                                </Form.Item></Col>
                        </Row>
                    </Form>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default BankAdminProfessionalDetails;
